module.exports = __webpack_public_path__ + "static/media/bank.c913d634.png";